/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1EmployeepostId202,
  DeleteApiV1EmployeepostId401,
  DeleteApiV1EmployeepostId404,
  DeleteApiV1EmployeepostId500,
  DeleteApiV1EmployeepostIdMutationResponse,
  DeleteApiV1EmployeepostIdPathParams,
} from "../../types/employeePostController/DeleteApiV1EmployeepostId.ts";

export const deleteApiV1EmployeepostIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1EmployeepostIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1EmployeepostId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1EmployeepostId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1EmployeepostId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1EmployeepostId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1EmployeepostId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1EmployeepostId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1EmployeepostId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1EmployeepostId500>;

export const deleteApiV1EmployeepostIdMutationResponseSchema = z.lazy(
  () => deleteApiV1EmployeepostId202Schema,
) as unknown as ToZod<DeleteApiV1EmployeepostIdMutationResponse>;
